var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMaTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "bxmwnwsvsa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.899 9.28-5.747-5.746a.607.607 0 0 0-.468-.2H4.002c-.401 0-.668.267-.668.668v6.682c0 .2.066.334.2.468l5.747 5.747c.4.4.868.601 1.403.601s1.07-.2 1.403-.601l4.812-4.812c.802-.801.802-2.004 0-2.806zm-.936 1.872-4.811 4.811a.646.646 0 0 1-.936 0L4.67 10.417V4.67h5.747l5.546 5.546a.646.646 0 0 1 0 .936zm-7.952-3.81c0-.2-.067-.333-.2-.467-.067-.067-.134-.133-.2-.133-.268-.134-.535-.067-.736.133a.607.607 0 0 0-.2.468c0 .067 0 .2.067.267 0 .067.066.134.133.2.134.134.267.201.468.201.2 0 .334-.067.468-.2a.607.607 0 0 0 .2-.468z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bxmwnwsvsa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h20v20H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaTag);
export default __webpack_public_path__ + "static/media/ic-ma-tag.b6d301eea2d15f1b52c1b9d2c659bfb5.svg";
export { ForwardRef as ReactComponent };